import type { QuerySettings } from '@customTypes/index';
import type { SearchParams } from '@customTypes/types';
import { useQuery } from '@tanstack/react-query';

import { getAllActivityesList } from './request';

export const useGetAllActivityesListQuery = (
  params: SearchParams,
  settings?: QuerySettings<typeof getAllActivityesList>
) =>
  useQuery({
    queryKey: ['GetAllActivityesList', params.pageNumber],
    queryFn: () =>
      getAllActivityesList({
        config: {
          ...settings?.config,
          params: {
            pageNumber: params.pageNumber
          }
        }
      }),
    ...settings?.options
  });
